module.exports = __webpack_public_path__ + "img/_.7a887f5b.png";